"use client";

import { Instagram, Facebook, Twitter } from "lucide-react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex gap-6">
        <div className="h-5 w-16 bg-muted/20 animate-pulse rounded" />
        <div className="h-5 w-16 bg-muted/20 animate-pulse rounded" />
        <div className="h-5 w-16 bg-muted/20 animate-pulse rounded" />
      </div>;
  }
  return <NavigationMenu viewport={false}>
      <NavigationMenuList className="gap-6">
        {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
            <NavigationMenuLink asChild>
              <Link to={item.href || "#"} className="text-foreground hover:text-foreground text-sm font-medium relative after:absolute after:bottom-0 after:left-0 after:h-[1px] after:w-0 after:bg-foreground after:transition-all after:duration-[var(--duration-medium)] hover:after:w-full">
                {item.label}
              </Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
export default function Footer() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  const socialLinks = [{
    icon: Instagram,
    href: "#",
    label: "Instagram"
  }, {
    icon: Facebook,
    href: "#",
    label: "Facebook"
  }, {
    icon: Twitter,
    href: "#",
    label: "Twitter"
  }];
  return <footer ref={ref} className="bg-dark-background py-12 transition-all duration-[var(--duration-slow)] opacity-100 translate-y-0 !bg-[url(https://vanessabrian.com/wp-content/uploads/2026/02/green-background.jpg)]">
      <div className="container mx-auto px-4 max-w-7xl">
        <div className="flex flex-col items-center gap-8 !bg-[url(https://vanessabrian.com/wp-content/uploads/2026/02/green-background.jpg)]">
          <Link to="/" className="block">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1508139/img/vanessabrian_wedding_logo.png" alt="Vanessa & Brian" className="h-7" />
          </Link>

          <MenuProvider menu_id="4" className="w-full flex justify-center">
            <FooterMenuConsumer />
          </MenuProvider>

          <img src="https://vanessabrian.com/wp-content/uploads/2026/02/Luffy.png" alt="Vanessa and Brian" className="w-full max-w-2xl rounded-lg object-cover !bg-transparent" />
        </div>
      </div>
    </footer>;
}